








































import isValidPath from 'is-valid-path';
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import TaskMetadataArgHint from '@/components/atoms/TaskMetadataArgHint.vue';
import TaskMetadataArgLabel from '@/components/atoms/TaskMetadataArgLabel.vue';
import TextField from '@/components/atoms/TextField.vue';
import { TextRuleType } from '@/components/atoms/neon/CustomTextField.vue';
import CustomToggle from '@/components/atoms/neon/CustomToggle.vue';
import { i18n } from '@/plugins/i18n/i18n';
import { TaskMetadataArgsHint, TaskMetadataArgsLabel } from '@/types/type';

@Component({
  components: {
    CustomToggle,
    TextField,
    TaskMetadataArgHint,
    TaskMetadataArgLabel,
  },
})
export default class TextFieldWithLabelAndHint extends Vue {
  @Prop()
  private duplicateOutputPathExist!: boolean;

  @Prop()
  private labels!: TaskMetadataArgsLabel[];

  @Prop()
  private hints!: TaskMetadataArgsHint[];

  @Prop({ required: false, default: '' })
  private sampleInput!: string;

  @Prop({ required: false, default: false })
  private isRequired!: boolean;

  @Prop({ required: false, default: false })
  private isOutputFile!: boolean;

  @Prop({ required: false, default: false })
  private isInputFile!: boolean;

  @Prop({ required: false, default: false })
  private showDownloadToggle!: boolean;

  @Prop({ required: false, default: false })
  private showReplaceInFileNameToggle!: boolean;

  @Prop()
  private value!: string;

  @Prop()
  private index!: number;

  @Prop({ required: false, default: 'text' })
  private type!: string;

  @Prop()
  private includeInDownload!: boolean;

  @Prop()
  private replaceInFileName!: boolean;

  private get prefix(): string {
    if (this.isOutputFile || this.isInputFile) {
      return '/nfsroot/interface/client';
    }
    return '';
  }

  private get showIncludeInDownloadSwitch(): boolean {
    return this.showDownloadToggle;
  }

  private get showReplaceInFileNameSwitch(): boolean {
    return this.showReplaceInFileNameToggle;
  }

  private get errorMessageForDuplicateOutputPath() {
    if (this.isOutputFile && this.value && this.duplicateOutputPathExist) {
      return this.$t('jobScheduler.jobs.duplicateOutputFilePath');
    }
    return '';
  }
  private ruleInputRequired = i18n.tc('portal.ruleInputRequired');
  private rules: { [key: string]: TextRuleType } = {
    required: value => !this.isRequired || !!value || this.ruleInputRequired,
    pathValidation: value => {
      if (!this.isOutputFile && !this.isInputFile) return true;
      return (
        (isValidPath(value) &&
          !value.includes('\\') &&
          value.startsWith('/') &&
          !value.includes('..') &&
          !value.includes('~')) ||
        this.rulePathValidation
      );
    },
  };

  private get rulePathValidation(): string {
    if (this.isOutputFile || this.isInputFile) {
      return i18n.tc('jobScheduler.jobs.invalidPath');
    }
    return '';
  }

  @Emit('changeInText')
  private changeInText(value: string) {
    return {
      index: this.index,
      value,
    };
  }

  @Emit('changeInIncludeInDownload')
  private changeInIncludeInDownload(value: boolean) {}

  @Emit('changeInReplaceInFileName')
  private changeInReplaceInFileName(value: boolean) {}
}
